<template>
    <div>
        <b-table 
            striped 
            hover 
            selectable 
            select-mode="single" 
            @row-selected="onRowSelected" 
            :items="seasonRoutes" 
            :fields="fields" 
            :filter="filter"
            @filtered="onFiltered"
            :sort-by.sync="sortBy"            
            :per-page="perPage"
            :current-page="currentPage">

            <template v-slot:cell(published)="{ item }">
                <p class="mb-0">
                    <b-icon icon="check-circle" variant="success" v-if='item.published' @click="togglePublish(item)" 
                    font-scale="1.2" v-b-tooltip.hover :title="$t('season.published')" 
                    class="clickable"></b-icon>
                    <b-icon icon="x-circle" variant="secondary" v-if='!item.published' @click="togglePublish(item)" 
                    font-scale="1.2" v-b-tooltip.hover :title="$t('season.unpublished')" 
                    class="clickable"></b-icon>
                </p>
            </template>
        </b-table>

        <TablePagination 
            :total-rows="totalRows" 
            :per-page="perPage" 
            @pageChange="onPageChange">
        </TablePagination>
    </div>
</template>

<script>

import TablePagination from '@/components/Misc/TablePagination'

export default {
    components: { TablePagination },
        props: ['filter', 'item'],
        data() {
            return {
                perPage: 10,
                currentPage: 1,
                filteredRows: 0,
                fields: [
                    { key: "route", label: this.$t('season.id'), sortable:"true" },
                    { key: "id", label: this.$t('season.explanation'), sortable:"true" },
                    { key: "published", label: this.$t('season.published'), sortable:"true" }
                ],
                sortBy:"route",               
                seasonRoutes: [],
                ok: false,
                error: false,
                loading: false,
                infoType: "save"
            }
    },
    computed: {
        totalRows() {
            return this.filter ? this.filteredRows : (this.seasonRoutes ? this.seasonRoutes.length : 0);
        },               
        selectedSeasonRoutes() {
            var selectedItems = [];
            
            for (var ug of this.seasonRoutes) {
                if( ug.selected ) {
                    selectedItems.push(ug);
                }
            }
            return selectedItems;               
        }                             
    },
    created() {
        this.getSeasonRoutes(this.item.id);
    },
    watch: {
        item: function(item) {
            this.getSeasonRoutes(item.id);
            this.ok = this.error = this.loading = false;  
        },        
    }, 
    methods: {
        togglePublish(item) {
            if (item.id) {
                this.$store.dispatch('timetable/updateSeasonRoute' , item, item.id).then( response => {
                    this.ok = response.data.errorCode == 0;
                    this.getSeasonRoutes(item.id);
                }), () => {
                }
            }        
        },
        getSeasonRoutes(item) {
            this.$store.dispatch('timetable/getSeasonRoutes' , item).then( response => {
                this.seasonRoutes = response.data.seasonRoutes;
            });                
        },
        listContains(item, list) {
            for(var i = 0; i < list.length; i++) {
                if(list[i].id === item.id) {
                    return true;
                }
            }
            return false;
        },    
        updateList(item, list) {
            for(var i = 0; i < list.length; i++) {
                if(list[i].id === item.id) {
                    list[i].selected = true;
                }
            }
        },    
        onRowSelected(items) {
            this.$emit('selectItem', items[0]);
        },
        onFiltered(filteredItems) {
            this.filteredRows = filteredItems.length;
            this.currentPage = 1
        },
        onPageChange(page){
            this.currentPage = page
        }
    }
}
</script>
